import React from "react";
import CuttingListItem from "../../components/cutting/CuttingList/CuttingListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const CuttingListPage = ()  => {

    useTitle(t`List Cutting`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <CuttingListItem showAdd={true} {...query} />
        </Box>
    )
}

export default CuttingListPage;
